import {SxProps, Theme} from '@mui/material'

export const getResponsivePopoverStyle = (theme: Theme) => ({
  marginTop: 2,
  color: theme.palette.text.primary,
  '@media only screen and (max-width: 410px)': {
    display: 'flex',
    justifyContent: 'center',
    left: '0 !important',
    width: '100%',
    maxWidth: '100%'
  }
})

export const stoppageToggleButtonGroupSx: SxProps<Theme> = (theme) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.grey[100],
  flexWrap: 'wrap',
  gap: 0.5,
  p: 0.5,
  '& .MuiToggleButtonGroup-grouped': {
    flex: `1 1 calc(33% - ${theme.spacing(1)})`,
    m: 0
  }
})
